import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	getClientsRecords (query) {

		let url = `${config.api.baseUrl}/api/clientsRecords`

		if(query){
			let esc = encodeURIComponent;
			let _query = Object.keys(query)
				.map(k => `${esc(k)}=${esc(query[k])}`)
				.join('&');
			url += `?${_query}`
		}

		// let url = config.api.baseUrl + '/api/clientsRecords' + data

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)

	},
	searchClient (query) {

		let url = `${config.api.baseUrl}/api/clientsRecords/search-client`

		if(query){
			let esc = encodeURIComponent;
			let _query = Object.keys(query)
				.map(k => `${esc(k)}=${esc(query[k])}`)
				.join('&');
			url += `?${_query}`
		}

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)

	},
	approveClientsRecords (data) {

		let url = config.api.baseUrl + '/api/clientsRecords/approve'

		return HTTP
			.request()
			.put(url, data)
			.then(response => response)
			.catch(error => error)

	},
	disapproveClientsRecords (data) {

		let url = config.api.baseUrl + '/api/clientsRecords/disapprove'

		return HTTP
			.request()
			.put(url, data)
			.then(response => response)
			.catch(error => error)

	},
	exportClientsRecords (data) {

		let url = config.api.baseUrl + '/api/clientsRecords/export'

		return HTTP
			.request()
			.post(url, data, {
				responseType : 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)

	}
}



// WEBPACK FOOTER //
// ./src/api/clients-records.js